import * as React from 'react';
import { useIntersectionObserver } from 'src/hooks/useIntersectionObserver';
import { isHeadless } from '../IntersectionObserverWrapper/utils';
import GhostCategory from './GhostCategory';
import styles from './Category.module.scss';
import CategoryRenderer, {
  CategoryRendererWithSlidesPropTypes,
} from './Category';

const CategoryHolder: React.FC<CategoryRendererWithSlidesPropTypes> = props => {
  const { ref, intersected } = useIntersectionObserver(isHeadless);

  return (
    <div ref={ref} className={styles.singleWrapper}>
      {intersected ? (
        <CategoryRenderer {...props} />
      ) : (
        <GhostCategory category={props.category} />
      )}
    </div>
  );
};

export default CategoryHolder;
